import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";

export const wsPostValidaOnline = (dtoTurno, nextStep) => {
  axiosAutoCheck().then((respuesta) => {
    respuesta
      .post(`/turno/validarOnline`,  dtoTurno)
      .then((resp) => {
        if (nextStep) nextStep(true,resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err);
      });
  });
};

export const wsGetValidaOnlineToken = (idTurno, nextStep) => {
  axiosAutoCheck().then((respuesta) => {
    respuesta
      .get(`/turnos/VerifaValidarOnLineToken/${idTurno}`)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, { token: true });
      });
  });
};
